import { CODE_FORMATS } from "../code-formats";
import { CODE_PATTERNS, CODE_PATTERNS_REGEX } from "../code-patterns";

import { type CodeValidationResult } from "./validate";

export function validateChildId(code: string): CodeValidationResult | null {
  const match = CODE_PATTERNS_REGEX.QR_CHILD_ID.exec(code);
  if (!match) return null;

  const value = match.groups?.childId;
  if (!value) return null;

  return {
    format: CODE_FORMATS.QR_CHILD_ID,
    patterns: [CODE_PATTERNS.QR_CHILD_ID],
    value
  };
}
